<template>
  <v-dialog v-model="modal" max-width="700">
    <v-form ref="form" :readonly="working">
      <v-card>
        <v-card-title> Supprimer le rattachement</v-card-title>
        <v-card-text>
          <p>
            Vous allez supprimer ce rattachement.
          </p>
          <v-textarea
            dense
            filled
            label="Motif suppression"
            v-model.trim="observations"
            :rules="[requiredRule(), serverRule('commentaire')]"
            data-testid="motif-suppression"
          />
          <p>Confirmez-vous la suppression ?</p>
        </v-card-text>
        <v-card-actions>
          <v-btn data-testid="valider-suppression-usager" :loading="working" @click="valide" color="primary"> Supprimer </v-btn>
          <v-btn data-testid="annuler-suppression-usager" :disabled="working" @click="ferme">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import makeRules from "@/mixins/makeRules";
import makeDialog from "@/mixins/makeDialog";
import { associationService } from "@/services";
export default {
  mixins: [
    makeRules({ inject: false }),
    makeRemoteWorker({ provide: false }),
    makeDialog,
  ],
  data() {
    return {
      sujet: null,
      observations: null,
      association: null,
    };
  },
  methods: {
    demarre(association, sujet, next) {
      this.sujet = sujet;
      this.association = association;
      this.observations = null;
      this.ouvre(next);
      this.$nextTick(()=>{
        this.$refs.form.resetValidation();
      });
    },

    valide() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return associationService.supprimerUsager(this.association, this.sujet, this.observations);
        },
        callback(data) {
          this.confirmeValeur(data);
        },
        successText: "Le rattachement a été supprimé.",
        errorText: "Erreur durant la suppression du rattachement.",
      });
    },
  },
};
</script>
